import superviseContractApi from '@/api/park/superviseContract';
export default {
  methods: {
    btnGroupHandler(clickName, params) {
      console.log(clickName, '按钮事件');
      this[clickName](params);
    },
    // 保存
    async saveHandler() {
      this.saveOrSubmitHandler(0);
    },
    // 提交
    submitHandler() {
      this.saveOrSubmitHandler(1);
    },
    // 取消
    cancelHandler() {
      this.closeCurrentAndToList();
      const path = {
        path: '/park/superviseContract/list',
        name: 'list',
        meta: {
          keepAlive: false,
          title: '监管合同列表',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },

    // 编辑
    editHandler() {
      const path = {
        path: '/park/superviseContract/detail',
        name: 'detail',
        meta: {
          keepAlive: false,
          title: '监管合同维护',
        },
        query: {
          status: 'edit',
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 补充协议
    supplementAgreementHandler() {
      const path = {
        path: '/park/superviseContract/agreement',
        name: 'agreement',
        meta: {
          keepAlive: false,
          title: '补充协议',
        },
        query: {
          status: 'editAgreement',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 续签
    renewHandler() {
      const path = {
        path: '/park/superviseContract/renew',
        name: 'renew',
        meta: {
          keepAlive: false,
          title: '监管合同续签',
        },
        query: {
          status: 'renew',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 编辑协议
    editAgreementHandler() {
      const path = {
        path: '/park/superviseContract/agreement',
        name: 'agreement',
        meta: {
          keepAlive: false,
          title: '补充协议',
        },
        query: {
          status: 'editAgreement',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 保存协议
    saveAgreementHandler() {},
    // 关闭弹框
    closeHandler() {
      const { id, contractStatus } = this.formData;
      this.$refs.closeContractDialogRef.openDialog(id, contractStatus);
    },
    // 提交按钮
    async passHandler() {
      // this.passOrRejectHandlerByNo('01');
    },
    // 变更合同信息
    changeContractHandler() {
      const path = {
        path: '/park/superviseContract/change',
        name: 'change',
        meta: {
          keepAlive: false,
          title: '监管合同信息变更',
        },
        query: {
          status: 'change',
          contractNo: this.$route.query.contractNo,
          id: this.$route.query.id,
        },
      };
      this.$store.dispatch('tagsView/addTabView', path).then(() => {
        this.$nextTick(() => {
          this.$router.push(path);
        });
      });
    },
    // 变更主体
    changeHandler() {
      /**
       * 1.先走关闭合同逻辑
       * 2.走复制一份合同
       */
      this.changeRowData = {
        id: this.$route.query.id,
      };
      this.closeHandler();
    },
    // 删除
    deleteHandler() {
      const idList = [this.$route.query.id];
      this.$confirmAction('删除提示', '删除后将不可恢复，您确定要删除吗？')
        .then(async () => {
          const { data } = await this.$axios.post(`${superviseContractApi.DELETE_CONTRACT_BY_ID}`, {
            ids: idList,
          });
          if (data.code == 0) {
            this.$message.success('删除成功');
            this.resetBtnClick();
          } else {
            this.$message.error('删除成功');
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // 提交审批
    approvalHandler() {
      this.$refs.approvalDialogRef.openDialog({
        type: 1,
        id: this.$route.query.id,
        contractNo: this.formData.contractNo,
        companyCode: this.formData.companyCode,
        companyName: this.formData.companyName,
        departmentName: this.formData.departmentName,
      });
    },
    rejectHandler() {
      this.$refs.approvalDialogRef.openDialog({
        type: 2,
        id: this.$route.query.id,
        contractNo: this.formData.contractNo,
        companyCode: this.formData.companyCode,
        companyName: this.formData.companyName,
        departmentName: this.formData.departmentName,
      });
    },
    // 保存或者提交 operateFlag 0保存,1提交，2撤销
    async saveOrSubmitHandler(operateFlag) {
      const postData = await this.getDetailData();
      if (!postData) return;
      const {
        data: { code, msg },
      } = await this.$axios.post(superviseContractApi.SAVE_SUPERVISE_CONTRACT, {
        ...postData,
        operateFlag,
      });
      if (code === 0) {
        this.$message.success(msg);
        this.$router.push('/park/superviseContract/list');
        // 关闭当前的tag
        this.$store.dispatch('tagsView/delView', {
          path: '/park/superviseContract/detail',
          name: 'detail',
          meta: {
            keepAlive: false,
            title: '',
          },
          query: {},
        });
      } else {
        this.$message.error(msg);
      }
    },
    // 审批通过或者驳回 01-通过,02-驳回
    async approvalOrRejectHandlerByNo(applovalResult) {
      const pageDetail = await this.getDetailData();
      if (!pageDetail) return;
      // 通过原因
      const approvalComment = await this.$refs.approvalFormRef.getValidateFormData();
      const postData = {
        ...pageDetail, // 表单表格数据
        applovalResult,
        approvalComment,
        approvalContractType: '01',
        approvalDataNo: this.$route.query.contractNo,
      };
      const { data } = await this.$axios.post(
        superviseContractApi.APPROVAL_SUPERVISE_CONTRACT,
        postData
      );
      if (data.code == 0) {
        this.$message.success(data.msg);
        this.$router.push('/park/superviseContract/list');
      } else {
        this.$message.error(data.msg);
      }
    },
    // 获取页面表单表格数据
    async getDetailData() {
      // 1.表单数据
      const baseFormData = await this.$refs.baseInfoFormRef.getValidateFormData();
      console.log(baseFormData, '基础信息');
      // 2.仓库信息
      const { tableData: storageLines, deleteStorageLineIds } =
        await this.$refs.storageLinesRef.getValidateTableData();
      console.log(storageLines, 'storageLines');
      // 3.结算行数据
      const { tableData: settlementLines, deleteSettlementLineIds } =
        await this.$refs.settlementLinesRef.getValidateTableData();
      settlementLines.forEach((item) => {
        item.expenseType = '01';
      });
      console.log(settlementLines, 'settlementLines');
      // 结算明细数据
      const { tableData: settlementDetails, deleteSettlementDetailIds } =
        await this.$refs.settlementDetailRef.getValidateTableData();
      // if (!settlementDetails.length && !baseFormData.settlementEntityName) {
      //   this.$message.error('请检查“结算主体”是否填写');
      //   return;
      // }
      // 4.附件
      const attachments = this.attachments;
      // 监管协议
      const isRequired = this.attachments.find((item) => item.fileType == '01');
      if (!isRequired) {
        this.$message.error('请检查“监管协议”是否上传');
        return;
      }
      // 5.判断附件
      // const attachmentsFileType = attachments.map((item) => item.fileType);
      // console.log(attachmentsFileType, '222');
      // const isExist = this.fileTypeList
      //   .filter((item) => item.value != '04')
      //   .every((item) => attachmentsFileType.includes(item.value));
      // console.log(isExist, '333');
      // if (!isExist) {
      //   this.$message.error('请检查监管协议、监管通知书、监管通知书确认函是否全部上传');
      //   return;
      // }
      // 6.判断结算行中的总金额和表单中是否一致
      const settlementLinesAmount = settlementLines.reduce(
        (pre, cur) => pre + +cur.perPeriodCost * +cur.serviceCycle,
        0
      );
      console.log(settlementLinesAmount, baseFormData.contractAmount, '金额');
      if (settlementLinesAmount != baseFormData.contractAmount) {
        this.$message.error('合同金额与结算信息行合计金额不相等，请修改！');
        return;
      }
      console.log('444');
      const currentStatus = this.$route.query.status;
      const oldContractId = this.$route.query.id;

      const postData = {
        ...baseFormData,
        oldContractId: currentStatus == 'renew' ? oldContractId : '', // 单独处理续签的时候
        id: currentStatus == 'renew' ? '' : baseFormData.id, // 单独处理续签的时候
        oaId: this.userInfo.oaId, // 审批时候需要用的
        storageLines,
        deleteStorageLineIds,
        settlementLines,
        settlementDetails,
        deleteSettlementLineIds,
        deleteSettlementDetailIds,
        attachments: attachments.map((item) => {
          return {
            ...item,
            // 特殊处理id
            id:
              ['create', 'renew'].includes(currentStatus) && this.contractStatus != '01'
                ? ''
                : item?.id,
          };
        }),
      };
      return postData;
    },
    closeCurrentAndToList() {
      this.$store.dispatch('tagsView/delView', {
        path: '/park/superviseContract/detail',
        name: 'detail',
        meta: {
          keepAlive: false,
          title: '',
        },
        query: {},
      });
    },
  },
};
